import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import type { RegisterSearch } from './register'
import { rootRoute } from './root'

const PokerRegister = lazyRouteComponent(() => import('../pages/poker-register'))

export const pokerRegisterRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/poker-register',
  component: PokerRegister,
  validateSearch: (search: Record<string, unknown>): RegisterSearch => {
    return search
  },
})
